import { AccountTypes } from './account-types';

export const CidAccountTypes = [
  AccountTypes.SDoHProviderAdmin,
  AccountTypes.ReferralProgramProviderAdmin,
  AccountTypes.SpecialtyProgramProviderAdmin,
];
  